// ER-diagram client: fetch a whole database's table + foreign-key graph in one
// call. Returns { database, tables:[{name, rows, columns:[{name,type,pk,fk,
// nullable,autoInc}]}], edges:[{name,fromTable,fromCols,toTable,toCols,onUpdate,onDelete}] }.
import { api } from './api.js';

export const fetchERGraph = (connectionId, database) =>
  api.get(`/api/connections/${connectionId}/databases/${encodeURIComponent(database)}/er-graph`);
